import type { CanvasArtifactSummary } from '@/lib/canvas/shared';
import type { ReportSummary } from './types';

export type LibraryKind = 'all' | 'doc' | 'asset';
export type LibrarySort = 'updated' | 'name';
export type LibraryItem =
  | { kind: 'doc'; value: ReportSummary }
  | { kind: 'asset'; value: CanvasArtifactSummary };

export function collectDocsAndAssets(
  reports: ReportSummary[],
  assets: CanvasArtifactSummary[]
): LibraryItem[] {
  return [
    ...reports.map(value => ({ kind: 'doc' as const, value })),
    ...assets.map(value => ({ kind: 'asset' as const, value })),
  ].filter(item => item.value.status !== 'archived');
}

export function filterDocsAndAssets(
  items: LibraryItem[],
  { kind, query, sort }: { kind: LibraryKind; query: string; sort: LibrarySort }
): LibraryItem[] {
  const terms = query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
  return items
    .filter(
      item =>
        (kind === 'all' || item.kind === kind) &&
        terms.every(term => item.value.title.toLocaleLowerCase().includes(term))
    )
    .sort((left, right) => {
      const byName = left.value.title.localeCompare(right.value.title);
      return sort === 'name'
        ? byName
        : Date.parse(right.value.updatedAt) - Date.parse(left.value.updatedAt) || byName;
    });
}
